module.exports = __webpack_public_path__ + "img/lens-160-plus-03.b91cbf12.png";